import { STAGE_STATE_COLORS, fmtDay } from "@/lib/api";

const SHORT = {
  "Model Development": "Model Dev.",
  "Baseline Signed Off": "Baseline signed",
  "Assessment Period Completed": "Assessment done",
  "Final Signoff & Handover": "Signoff",
};

/** The major sub-stage dates a reviewer asks for — "To be updated" until a SPOC fills them. */
export const StageDates = ({ project, compact = false }) => {
  const rows = project?.stage_dates_view || [];
  if (!rows.length) return null;
  return (
    <div
      className={`flex flex-wrap ${compact ? "gap-1" : "gap-1.5"}`}
      data-testid={`stage-dates-${project.code}`}
    >
      {rows.map((r) => {
        const colour = STAGE_STATE_COLORS[r.state] || STAGE_STATE_COLORS.pending;
        const date = r.completed_on || r.reached_on || r.expected_on;
        return (
          <span
            key={r.stage}
            title={`${r.stage} — ${r.label}`}
            data-testid={`stage-date-${project.code}-${r.stage.replace(/[\s/&]+/g, "-")}`}
            className={`inline-flex items-center gap-1.5 border bg-card ${
              compact ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-1 text-[11px]"
            }`}
            style={{ borderColor: colour }}
          >
            <span className="inline-block h-1.5 w-1.5 shrink-0" style={{ backgroundColor: colour }} />
            <span className="text-muted-foreground">{SHORT[r.stage] || r.stage}</span>
            <span className="font-data font-semibold" style={{ color: colour }}>
              {date ? fmtDay(date) : "To be updated"}
            </span>
            {r.revision && (
              <span
                data-testid={`stage-revision-${project.code}-${r.stage.replace(/[\s/&]+/g, "-")}`}
                title={`Revised — first committed ${fmtDay(r.committed_on)}`}
                className="font-data border px-1 text-[9px] font-bold"
                style={{ borderColor: "hsl(36 92% 44%)", color: "hsl(36 92% 44%)" }}
              >
                {r.revision} · was {fmtDay(r.committed_on)}
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
};
